import React, { FC } from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { errorToast } from "../../Utils/toastMessage";

const CustomToast: FC = () => {
    
    return (
        <>
        {/* {errorToast(JSON.stringify(`Unable to connect with Purchase Order service and resons is: (${data})`))} */}
            <ToastContainer
                style={{ width: "450px" }}
            />
        </>

    )
}

export default CustomToast